import React from 'react'
import { Line, Text } from 'react-konva';

const Linea = ({vertices, id}) => {

  const puntoMedio = (p1, p2) =>{
    const punto = (p1+p2)/2;
    return punto;
  }

  return (
    <>
      <Line
        id={id}
        points={vertices}
        stroke='#201E1F'
        strokeWidth= {5}
        lineCap='round'
        lineJoin='round'
        /* onTap={()=>{console.log(vertices[0])}} */
      />
    </>

  )
}

export default Linea;